import type { SessionArtifactFileSummary } from "../chat/chat-file-changes-summary.ts";

export type RunArtifactPreviewEntry = SessionArtifactFileSummary & {
  changeId: string;
  previewLines: string[];
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function parseSessionArtifactRecorded(payload: unknown): {
  sessionKey: string;
  entry: RunArtifactPreviewEntry;
} | null {
  if (!isRecord(payload)) {
    return null;
  }
  const sessionKey = typeof payload.sessionKey === "string" ? payload.sessionKey.trim() : "";
  const change = payload.change;
  if (!sessionKey || !isRecord(change)) {
    return null;
  }
  const id = typeof change.id === "string" ? change.id.trim() : "";
  const path = typeof change.path === "string" ? change.path.trim() : "";
  const op = change.op;
  if (!id || !path) {
    return null;
  }
  if (op !== "created" && op !== "modified" && op !== "deleted" && op !== "manual") {
    return null;
  }
  const additions = typeof payload.additions === "number" ? payload.additions : 0;
  const deletions = typeof payload.deletions === "number" ? payload.deletions : 0;
  const previewRaw = payload.previewLines;
  const previewLines = Array.isArray(previewRaw)
    ? previewRaw.filter((l): l is string => typeof l === "string")
    : [];
  return {
    sessionKey,
    entry: {
      changeId: id,
      path,
      op,
      additions,
      deletions,
      sessionKey,
      previewLines,
    },
  };
}

export function mergeRunArtifactPreview(
  list: RunArtifactPreviewEntry[],
  entry: RunArtifactPreviewEntry,
  max = 12,
): RunArtifactPreviewEntry[] {
  // Match the TUI FileChangesPanel.addChange ordering: newest at the front.
  // Earlier versions pushed to the end, which made the live WebUI file-changes
  // strip show oldest-first — opposite of what users expect from a live indicator.
  const next = list.filter((e) => e.path !== entry.path);
  next.unshift(entry);
  if (next.length > max) {
    return next.slice(0, max);
  }
  return next;
}
